import client from "@/lib/api/base";
import { User } from "./common";

// @[login]
interface LoginCredentials {
  email: string;
  password: string;
}
interface LoginResponse {
  token: string;
  user: User;
}
export async function login(
  credentials: LoginCredentials
): Promise<LoginResponse> {
  const res = await client
    .post<LoginResponse>("auth/login", {
      json: credentials,
    })
    .json();
  return res;
}

// @[logout]
export async function logout(): Promise<void> {
  await client.post("auth/logout");
}

// @[me]
export async function me(): Promise<User> {
  const res = await client.post<User>("auth/me").json();
  return res;
}

// @[refresh]
export async function refresh(): Promise<LoginResponse> {
  const res = await client.post<LoginResponse>("auth/refresh").json();
  return res;
}

// @[change password]
export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}
export async function changePassword(request: ChangePasswordRequest) {
  const res = await client
    .patch<{ message: string }>("auth/password", { json: request })
    .json();
  return res;
}

// @[forgot password]
export interface RequestPasswordResetRequest {
  email: string;
}
export async function requestPasswordReset(
  request: RequestPasswordResetRequest
) {
  const res = await client
    .post<{ message: string }>("auth/password/request-reset", { json: request })
    .json();
  return res;
}

// @[reset password]
export interface ResetPasswordRequest {
  token: string;
  password: string;
}
export async function resetPassword(request: ResetPasswordRequest) {
  const res = await client
    .post<{ message: string }>("auth/password/reset", { json: request })
    .json();
  return res;
}

// @[start registration]
export interface StartRegistrationRequest {
  fullName: string;
  email: string;
  username: string;
}
export interface StartRegistrationResponse {
  orderId: string;
}
export async function startRegistration(request: StartRegistrationRequest) {
  const res = await client
    .post<{ orderId: string }>("auth/register/start", { json: request })
    .json();
  return res;
}

// @[complete registration]
export interface CompleteRegistrationRequest {
  orderId: string;
  paymentId: string;
  signature: string;
}
export interface CompleteRegistrationResponse {
  token: string;
  user: User;
}
export async function completeRegistration(request: CompleteRegistrationRequest) {
  const res = await client
    .post<CompleteRegistrationResponse>("auth/register/complete", { json: request })
    .json();
  return res;
}